import { motion } from "framer-motion";
import About from "./About";
import Skills from "./Skills";
import Contact from "./Contact";
import ToolsSection from "../components/ToolsSection";

const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 },
  transition: { duration: 0.7 },
};

const stats = [
  { label: "Projects", value: "4" },
  { label: "Languages", value: "2" },
  { label: "Lines", value: "2" },
  { label: "Online", value: "8/7" },
];

export default function Home() {
  return (
    <div className="space-y-28">
      <motion.section
        id="home"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="grid md:grid-cols-[1.1fr_0.78fr] items-center gap-10 md:gap-16 py-10 scroll-mt-24"
      >
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-2 rounded-full border border-white/10 bg-white/5 text-sm text-gray-400">
            <span className="w-2 h-2 rounded-full bg-[#49dda0] shadow-[0_0_10px_#49dda0]" />
            Đang hoạt động · Online
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold leading-tight tracking-tight mt-6 mb-5">
            Xin chào, tôi là <span className="gradient-text">Nguyễn Nhật Duy</span>.
          </h1>
          <p className="text-gray-400 text-lg leading-relaxed max-w-xl">
            TiktokTools • DDoS • TKB - TínChỉ TVU • Networking • Minecraft
          </p>
          <div className="flex flex-wrap gap-3 mt-8">
            <a href="#tools" className="btn-gradient">Khám phá công cụ →</a>
            <a
              href="#contact"
              className="px-8 py-4 rounded-full font-semibold bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
            >
              Liên hệ với tôi
            </a>
          </div>
        </div>

        <div className="glass-card">
          <div className="w-[86px] h-[86px] rounded-full grid place-items-center bg-[#08111d] border-[3px] border-[#7b9dff] shadow-[0_0_0_5px_#101d36,0_0_35px_rgba(113,149,255,0.2)] font-extrabold text-xl mb-5">
            ND
          </div>
          <p className="text-xs tracking-wider text-gray-500 uppercase mb-2">Software Engineer</p>
          <h2 className="text-2xl font-bold mb-2">Cloud · Open Source · Networking</h2>
          <p className="text-gray-400">Xây dựng sản phẩm đơn giản, nhanh và dễ sử dụng.</p>
          <div className="grid grid-cols-2 gap-3 mt-6">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3">
                <strong className="block text-lg">{s.value}</strong>
                <small className="text-gray-500">{s.label}</small>
              </div>
            ))}
          </div>
        </div>
      </motion.section>

      <motion.div {...fadeUp}><ToolsSection /></motion.div>
      <motion.div {...fadeUp}><About /></motion.div>
      <motion.div {...fadeUp} id="skills" className="scroll-mt-24"><Skills /></motion.div>
      <motion.div {...fadeUp} id="contact" className="scroll-mt-24"><Contact /></motion.div>
    </div>
  );
}
